import React from 'react';
import TextField from '../../../components/inputs/textField';
import { TextLead } from '@awarego-ui/components';

const TextFieldWithRevert = ({
    field,
    defaultValue,
    onRevert,
    linkBelow = false,
    linkLabel = 'Revert to default',
}) => {
    const hasDefaultValue = defaultValue !== undefined && defaultValue !== null && defaultValue !== '';
    const isDifferent = hasDefaultValue && field.value !== defaultValue;

    const handleRevert = () => {
        if (hasDefaultValue && onRevert) {
            onRevert(field.name, defaultValue);
        }
    };

    const link = isDifferent ? (
        <TextLead
            themed
            bold
            link
            role="button"
            tabIndex={0}
            onClick={handleRevert}
            title={linkLabel}
            style={
                linkBelow
                    ? {
                          fontSize: '12px',
                          marginTop: '8px',
                          display: 'inline-block',
                      }
                    : {
                          position: 'absolute',
                          right: '8px',
                          top: '8px',
                          fontSize: '11px',
                      }
            }
        >
            {linkLabel}
        </TextLead>
    ) : null;

    return (
        <div style={{ position: 'relative' }}>
            <TextField field={field} />
            {link}
        </div>
    );
};

export default TextFieldWithRevert;

